/* Product tabs → mobile accordion */
(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
  }

  function buildAccordion(container) {
    if (!container || container.dataset.accordionBuilt === "1") return;

    const tabsList = container.querySelector("ul.tabs");
    if (!tabsList) return;

    const tabButtons = Array.from(tabsList.querySelectorAll("button.tab-btn"));
    const tabPanels  = Array.from(container.querySelectorAll(".tab-content"));

    if (!tabButtons.length || !tabPanels.length) return;

    const acc = document.createElement("div");
    acc.className = "product-tabs-accordion";

    tabButtons.forEach((btn, idx) => {
      const title = (btn.textContent || "").trim() || `Tab ${idx + 1}`;
      const panel = tabPanels[idx];
      if (!panel) return;

      const details = document.createElement("details");
      if (idx === 0) details.open = true;

      const summary = document.createElement("summary");
      summary.textContent = title;

      const body = document.createElement("div");
      body.className = "accordion-body";
      body.innerHTML = panel.innerHTML;

      details.appendChild(summary);
      details.appendChild(body);
      acc.appendChild(details);
    });

    container.appendChild(acc);
    container.dataset.accordionBuilt = "1";
  }

  function init() {
    const containers = document.querySelectorAll(".product-tabs-container");
    if (!containers.length) return;

    if (isMobile()) containers.forEach(buildAccordion);
  }

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("resize", init);
})();


/* Revolution Slider MOBILE banner fix (keep video slide untouched) */
(function () {
  const MOBILE_MAX = 768;

  function isMobile() {
    return window.matchMedia && window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
  }

  function closestSlide(el) {
    return el.closest("li, .rs-slide, .tp-revslider-slidesli, .tp-slide");
  }

  function slideHasVideo(slide) {
    if (!slide) return false;
    return !!slide.querySelector("video, .tp-videolayer, .tp-bgvideo, .rs-background-video-layer");
  }

  function setImportant(el, prop, value) {
    try { el.style.setProperty(prop, value, "important"); } catch (e) {}
  }

  function applyFixOnce() {
    if (!isMobile()) return;

    const wrappers = document.querySelectorAll(".rev_slider_wrapper, [id*='rev_slider'][id*='_wrapper']");
    wrappers.forEach((wrap) => {
      setImportant(wrap, "height", "clamp(300px, 70vw, 520px)");
      setImportant(wrap, "max-height", "none");

      const slider = wrap.querySelector(".rev_slider, .rev_slider_wrapper .rev_slider");
      if (slider) {
        setImportant(slider, "height", "clamp(300px, 70vw, 520px)");
        setImportant(slider, "max-height", "none");
      }

      const forcer = wrap.querySelector(".tp-fullwidth-forcer");
      if (forcer) {
        setImportant(forcer, "height", "clamp(300px, 70vw, 520px)");
        setImportant(forcer, "max-height", "none");
      }

      const bgLayers = wrap.querySelectorAll(".tp-bgimg, .rs-sbg-px, img.rev-slidebg");
      bgLayers.forEach((bg) => {
        const slide = closestSlide(bg);
        if (slideHasVideo(slide)) return;

        // background layer
        setImportant(bg, "background-size", "contain");
        setImportant(bg, "background-repeat", "no-repeat");
        setImportant(bg, "background-position", "center center");

        // img inside or the img itself
        const img = bg.tagName === "IMG" ? bg : bg.querySelector("img");
        if (img) {
          setImportant(img, "object-fit", "contain");
          setImportant(img, "object-position", "center center");
        }
      });
    });
  }

  function installObservers() {
    const wrappers = document.querySelectorAll(".rev_slider_wrapper, [id*='rev_slider'][id*='_wrapper']");
    wrappers.forEach((wrap) => {
      const mo = new MutationObserver(() => applyFixOnce());
      mo.observe(wrap, { childList: true, subtree: true, attributes: true });
    });
  }

  function boot() {
    let n = 0;
    const timer = setInterval(() => {
      applyFixOnce();
      n += 1;
      if (n >= 12) clearInterval(timer);
    }, 500);

    window.addEventListener("resize", applyFixOnce, { passive: true });
    window.addEventListener("orientationchange", applyFixOnce, { passive: true });

    installObservers();
    applyFixOnce();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();


/* HERO SLIDER DESKTOP full-width (works for RS/Slick/Swiper/Flickity) */
(function () {
  function isDesktop() {
    return window.matchMedia && window.matchMedia("(min-width: 769px)").matches;
  }

  function findPager() {
    return (
      document.querySelector(".tp-bullets") ||              // RS bullets
      document.querySelector("rs-bullets") ||               // RS6 bullets tag
      document.querySelector(".slick-dots") ||              // Slick
      document.querySelector(".swiper-pagination") ||       // Swiper
      document.querySelector(".flickity-page-dots") ||      // Flickity
      document.querySelector("[class*='dots']") ||
      document.querySelector("[class*='pagination']")
    );
  }

  function climb(el) {
    let node = el;
    for (let i = 0; i < 18 && node; i++) {
      node = node.parentElement;
      if (!node) break;

      if (node.classList && node.classList.contains("shopify-section")) return node;
      if (node.tagName === "SECTION") return node;

      if (node.classList && (node.classList.contains("container") || node.classList.contains("page-width") || node.classList.contains("tt-container"))) {
        return node;
      }
    }
    return el.parentElement;
  }

 function apply() {
  if (!isDesktop()) return;

  /* only homepage */
  if (!document.body.classList.contains("template-index")) return;

  const pager = findPager();
  if (!pager) return;

  const target = climb(pager);
  if (!target) return;

  /* extra safety: only if this block really contains Revolution Slider */
  if (
    !target.querySelector(
      ".rev_slider_wrapper, [id*='rev_slider'][id*='_wrapper'], rs-module-wrap, rs-module"
    )
  ) {
    return;
  }

  target.style.width = "100vw";
  target.style.maxWidth = "100vw";
  target.style.marginLeft = "calc(50% - 50vw)";
  target.style.marginRight = "calc(50% - 50vw)";
  target.style.paddingLeft = "0";
  target.style.paddingRight = "0";

  const inner = target.querySelectorAll(".container, .page-width, .tt-container, .tt-page__container");
  inner.forEach((c) => {
    c.style.maxWidth = "none";
    c.style.width = "100%";
    c.style.paddingLeft = "0";
    c.style.paddingRight = "0";
  });
}

  function boot() {
    // sliders often init late
    let tries = 0;
    const t = setInterval(() => {
      apply();
      tries++;
      if (tries >= 20) clearInterval(t);
    }, 500);

    window.addEventListener("resize", apply, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

// Видалення дубльованих іконок оплати на мобільних пристроях
document.addEventListener("DOMContentLoaded", function() {
    function fixTrustBadges() {
        const badges = document.querySelectorAll('.tt-product-single-info__trust-badge img');
        if (badges.length > 1) {
            if (window.innerWidth < 768) {
                // На мобільних видаляємо першу картинку (десктопну)
                badges[0].style.display = 'none';
                badges[1].style.display = 'block';
            } else {
                // На десктопі видаляємо другу картинку (мобільну)
                badges[0].style.display = 'block';
                badges[1].style.display = 'none';
            }
        }
    }

    // Запускаємо при завантаженні та при зміні розміру вікна
    fixTrustBadges();
    window.addEventListener('resize', fixTrustBadges);
});

/* Фікс дублювання іконок оплати */
document.addEventListener("DOMContentLoaded", function() {
  const badgeContainer = document.querySelector('.tt-product-single-info__trust-badge');
  if (badgeContainer) {
    const images = badgeContainer.querySelectorAll('img');
    if (images.length > 1) {
      // Видаляємо всі картинки, крім першої
      for (let i = 1; i < images.length; i++) {
        images[i].remove();
      }
    }
  }
});

/* Радикальне видалення дублів оплати в реальному часі */
const observer = new MutationObserver((mutations) => {
    const badgeContainer = document.querySelector('.tt-product-single-info__trust-badge');
    if (badgeContainer) {
        const images = badgeContainer.querySelectorAll('img');
        if (images.length > 1) {
            // Залишаємо тільки ПЕРШУ картинку, решту видаляємо фізично
            for (let i = 1; i < images.length; i++) {
                images[i].remove();
            }
        }
    }
});

// Починаємо стежити за змінами на всій сторінці
observer.observe(document.body, {
    childList: true,
    subtree: true
});